import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { AUDIT_TOKENS } from "../../theme/auditTokens";
import { AuditButton } from "../common/AuditButton";
import { SUMMARY_ID } from "./PeriodSummaryCard";

interface Props {
  open: boolean;
  onToggle: (open: boolean) => void;
}

/** Opens and closes the period summary card from the filter row. */
export function SummaryToggle({ open, onToggle }: Props) {
  const { t } = useTranslation();
  return (
    <AuditButton
      onClick={() => onToggle(!open)}
      aria-expanded={open}
      aria-controls={open ? SUMMARY_ID : undefined}
      sx={{
        height: 34,
        px: "10px",
        fontSize: 13,
        ...(open && { borderColor: AUDIT_TOKENS.ink }),
        "@media (max-width: 820px)": { minHeight: 44, height: 44, flex: "1 1 auto" },
      }}
    >
      {t("logbookAudit.summary.title")}
      <ExpandMoreIcon
        fontSize="small"
        aria-hidden
        sx={{
          color: AUDIT_TOKENS.muted,
          transform: open ? "rotate(180deg)" : "none",
          transition: "transform .15s",
          "@media (prefers-reduced-motion: reduce)": { transition: "none" },
        }}
      />
    </AuditButton>
  );
}
